import enquiryService from '@/services/enquiryService';

export default {
  namespaced: true,
  state: {
    enquirySubmitted: false,
    enquiryError: null
  },
  mutations: {
    SET_ENQUIRY_SUBMITTED(state, status) {
      state.enquirySubmitted = status;
    },
    SET_ENQUIRY_ERROR(state, error) {
      state.enquiryError = error;
    }
  },
  actions: {
    submitEnquiry({ commit }, enquiry) {
      return enquiryService.submitEnquiry({
        your_email: enquiry.email,
        your_telephone: enquiry.telephone || ''
      })
        .then(() => {
          commit('SET_ENQUIRY_SUBMITTED', true);
          commit('SET_ENQUIRY_ERROR', null);
        })
        .catch(error => {
          commit('SET_ENQUIRY_ERROR', error.response ? error.response.data : error.message);
          throw error;
        });
    },
    resetEnquiryForm({ commit }) {
      commit('SET_ENQUIRY_SUBMITTED', false);
      commit('SET_ENQUIRY_ERROR', null);
    }
  }
};